// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./components/Login/Login";
import Dashboard from "./pages/Dashboard";
import Companies from "./pages/Companies";
import Campeonatos from "./pages/Campeonatos";
import ListCategorias from "./pages/ListCategorias";
import Categoria from "./pages/Categoria";
import Admin from "./pages/Admin";
import AdminCompany from "./pages/AdminCompany";
import Users from "./pages/Users";
import Escenarios from "./pages/Escenarios";
import HandballScoreboardView from "./components/FullScreenModal/FullScreenPlanilla/Handball/components/scoreboard/HandballScoreboardView";
import HandballBeachScoreboardView from "./components/FullScreenModal/FullScreenPlanilla/HandballBeach/components/scoreboard/HandballBeachScoreboardView";
import AuthSessionBridge from "./components/global/AuthSessionBridge";

import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="font-quickSand">
      <Toaster position="top-right" />
      <BrowserRouter>
        {/* FTR-0019: 401 de la API o logout en otra pestaña → sesión expirada + login */}
        <AuthSessionBridge />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin-company" element={<AdminCompany />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/escenarios" element={<Escenarios />} />
          <Route path="/handball-scoreboard" element={<HandballScoreboardView />} />
          <Route path="/handballBeach-scoreboard" element={<HandballBeachScoreboardView />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/campeonatos" element={<Campeonatos />} />
          <Route
            path="/campeonatos/:idevent/list-categorias"
            element={<ListCategorias />}
          />
          <Route
            path="/campeonatos/:idevent/list-categorias/:idsport/deporte"
            element={<Categoria />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
